import dayjs, { Dayjs, unix } from "dayjs";

const storageKeyPrefix = "notified_visit:";
const NOTIFIED_VISIT_ID_KEY_PREFIX = /notified_visit:.+/;
const expirySeconds = 60 * 60 * 24 * 7; // 7 days

export const getNotifiedVisitIds = ({ storage }: { storage?: Storage }) => {
  if (!storage) return [];

  return Object.keys(storage)
    .filter((key) => NOTIFIED_VISIT_ID_KEY_PREFIX.test(key))
    .map((key) => key.replace(storageKeyPrefix, ""));
};

export const setNotifiedVisitIds = ({
  notifiedVisitIds,
  storage,
  storedAt = dayjs(),
}: {
  notifiedVisitIds: string[];
  storage: Storage;
  storedAt?: Dayjs;
}) => {
  notifiedVisitIds.forEach((visitId) => {
    storage.setItem(storageKeyPrefix + visitId, storedAt.unix().toString());
  });
};

export const removeExpiredNotifiedVisitIds = ({ storage }: { storage?: Storage }) => {
  if (!storage) return;

  try {
    for (const key of Object.keys(storage)) {
      if (!NOTIFIED_VISIT_ID_KEY_PREFIX.test(key)) continue;

      const value = storage.getItem(key);

      if (!value) continue;

      const passedSeconds = dayjs().diff(unix(parseInt(value)), "seconds");

      if (passedSeconds > expirySeconds) {
        storage.removeItem(key);
      }
    }
  } catch {
    console.warn("remove notified visits cannot be parsed", { storage });
  }
};
